import { inject, Pipe, PipeTransform } from '@angular/core';
import { USER } from '@marmon/frontend/common';
import { isAdmin, User } from '@marmon/shared/types/user';

@Pipe({ name: 'isAdmin' })
export class IsAdminPipe implements PipeTransform {
	private readonly user = inject(USER);

	transform(user: User | null) {
		// if no user is provided, use the current user
		user = user ?? this.user.value;
		if (!user) return false;
		return isAdmin(user);
	}
}
